module.exports = __webpack_public_path__ + "img/arbostar.8a46cfd6.svg";